import "./index.css";
import dayjs from "dayjs";
import { DatePicker, ConfigProvider } from "antd";
import "dayjs/locale/en-gb";
import updateLocale from "dayjs/plugin/updateLocale";
import locale from "antd/locale/en_GB";

dayjs.extend(updateLocale);
dayjs.updateLocale("en-gb", {
  weekStart: 1,
});

const { RangePicker } = DatePicker;

function DateRange(props) {
  const values = [dayjs(props.startDate), dayjs(props.startDate).add(props.numberOfDays - 1, "day")];
  return (
    <ConfigProvider locale={locale}>
      <div className="DateRange">
        <div>
          <RangePicker allowClear={false} value={values} onChange={props.onSetDateRange} />
        </div>
      </div>
    </ConfigProvider>
  );
}

export default DateRange;
